import {
  FLOW_FETCH_FORM_PERMISSIONS_SUCCESS,
  FLOW_UPDATE_FORM_PERMISSIONS,
} from 'actions/workflows/forms';

export const defaultState = {
  formPermissions: [],
};

export default function forms(state = defaultState, action) {
  const { type, payload } = action;

  switch (type) {
    case FLOW_FETCH_FORM_PERMISSIONS_SUCCESS: {
      return { ...state, formPermissions: payload.data };
    }
    case FLOW_UPDATE_FORM_PERMISSIONS: {
      const formPermissions = payload.map(
        ({ displayName, id, ...rest }) => rest,
      );
      return { ...state, formPermissions };
    }
    default:
      return state;
  }
}
